<template>
    <div class="active-wheel-rewards__list" v-if="activeWheelRewards.length > 0">
        <component :is="getComponent(reward.type)" v-for="reward in activeWheelRewards" :key="reward.id" :reward="reward" />
    </div>
</template>



<script setup>

import { computed } from 'vue';
import { SpinTheWheelStore } from '@/store/SpinTheWheelStore';
import { SectionType } from '@/constants/SpinTheWheel/SectionType';
import ActiveWheelRewardPercTile from './Active-Wheel-Reward-Perc-Tile.vue';
import ActiveWheelRewardBoostTile from './Active-Wheel-Reward-Boost-Tile.vue';
const spinTheWheelStore = SpinTheWheelStore();

const activeWheelRewards = computed(() => spinTheWheelStore.activeWheelRewards);

const getComponent = (type) => {
    return type === SectionType.FIXED_PERCENTAGE ? ActiveWheelRewardPercTile : ActiveWheelRewardBoostTile;
}

</script>